import { render, staticRenderFns } from "./TheTicketsChat.vue?vue&type=template&id=331d55a9&"
import script from "./TheTicketsChat.vue?vue&type=script&lang=js&"
export * from "./TheTicketsChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports